export const phoneString = value => String(value).replace(/\D+/g, '');
export const priceString = value => String(value || 0).replace(/[^-.\d]/g, '');
export const priceNumber = value => Number(priceString(value));